export default __webpack_public_path__ + "static/worksans-semibold-webfont-38c2e9f37d159b58472923c6c884d4ad.woff2";